const SlovakiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112361)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 39.9995C31.0456 39.9995 40 31.0451 40 19.9995C40 17.553 39.56 15.2095 38.756 13.043H1.24398C0.440078 15.2095 0 17.553 0 19.9995C0 31.0451 8.95437 39.9995 20 39.9995Z"
        fill="#0052B4"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M5.17139 11.3047V21.2817C5.17139 26.957 12.5855 28.696 12.5855 28.696C12.5855 28.696 19.9996 26.957 19.9996 21.2817V11.3047H5.17139Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.91064 11.3047V21.2817C6.91064 21.948 7.05861 22.5772 7.35174 23.1671H17.8195C18.1126 22.5773 18.2606 21.948 18.2606 21.2817V11.3047H6.91064Z"
        fill="#D80027"
      />
      <path
        d="M16.0644 18.2603H13.4558V16.5212H15.1949V14.782H13.4558V13.043H11.7167V14.782H9.9776V16.5212H11.7167V18.2603H9.10791V19.9995H11.7167V21.7386H13.4558V19.9995H16.0644V18.2603Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.72465 25.595C10.8454 26.2993 11.9968 26.7082 12.5862 26.8901C13.1757 26.7083 14.3271 26.2993 15.4478 25.595C16.5779 24.8847 17.3702 24.0724 17.82 23.1673C17.3239 22.8163 16.7185 22.6093 16.0645 22.6093C15.8264 22.6093 15.595 22.6375 15.3726 22.6893C14.9013 21.6183 13.8314 20.8701 12.5863 20.8701C11.3412 20.8701 10.2712 21.6183 9.79996 22.6893C9.57754 22.6375 9.34613 22.6093 9.10809 22.6093C8.4541 22.6093 7.84871 22.8163 7.35254 23.1673C7.80215 24.0723 8.59441 24.8846 9.72465 25.595Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112361">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SlovakiaSvg;
